import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const TEST_SELECTORS = {
    nameWrapper: generateAutomationName("step", ["name", "wrapper"]),
    title: generateAutomationName("step", ["name", "title"]),
    inputTitle: generateAutomationName("step", ["name", "input", "title"]),
    chip: generateAutomationName("step", ["name", "chip"]),
    body: generateAutomationName("step", ["name", "body"]),
    tooltip: generateAutomationName("step", ["name", "tooltip"]),
    subscriptionText: generateAutomationName("step", ["name", "subscription", "text"]),
    switcherWrapper: generateAutomationName("step", ["name", "subscription", "switcher", "wrapper"]),
    infoIcon: generateAutomationName("step", ["name", "info", "icon"]),
};
